<template>
  <div class="container">
    <!-- 头部banner -->
    <top-banner></top-banner>
    <!-- 轮播 -->
    <img src="@/common/images/nodeService/banner_dfhj.png" class="banner_dfhj" />
    <!-- 占位撑开 -->
    <div class="zwdf"></div>
    <!-- menu标题栏 -->
    <div class="menu_dfhj">
      <img src="@/common/images/nodeService/menu_dfhj_bg.png" class="img_dfhj" />
      <div class="line_dfhj">
        <div class="menu_item" v-for="(item,index) in menuList" :key="index" :class="{ 'menu_item_active': item.show }"
          @mouseover="item.show=true" @mouseout="item.show=false" @click="showContent(index)">
          <img :src="item.imgUrl" class="menu_icon" v-show="!item.show" />
          <img :src="item.imgUrl2" class="menu_icon" v-show="item.show" :class="{ 'flipInX': item.show }" />
          {{item.title}}
        </div>
      </div>
    </div>
    <node-s1 v-if="curIndex==0"></node-s1>
    <node-s2 v-if="curIndex==1"></node-s2>
    <node-s3 v-if="curIndex==2"></node-s3>
    <node-s4 v-if="curIndex==3"></node-s4>
    <node-s5 v-if="curIndex==4"></node-s5>
  </div>
</template>

<script>
  import topBanner from '@/components/topBanner.vue'
  import nodeS1 from '@/components/nodeS1.vue'
  import nodeS2 from '@/components/nodeS2.vue'
  import nodeS3 from '@/components/nodeS3.vue'
  import nodeS4 from '@/components/nodeS4.vue'
  import nodeS5 from '@/components/nodeS5.vue'
  export default {
    name: 'nodeService',
    components: {
      topBanner,
      nodeS1,
      nodeS2,
      nodeS3,
      nodeS4,
      nodeS5
    },
    data() {
      return {
        curPage:'nodeService',
        menuList: [{
          title: '企业介绍',
          imgUrl: require('@/common/images/nodeService/qyjs.png'),
          imgUrl2: require('@/common/images/nodeService/qyjs1.png'),
          url: '',
          show: false,
        }, {
          title: '企业文化',
          imgUrl: require('@/common/images/nodeService/qywh.png'),
          imgUrl2: require('@/common/images/nodeService/qywh1.png'),
          url: '',
          show: false,
        }, {
          title: '发展历程',
          imgUrl: require('@/common/images/nodeService/fzlc.png'),
          imgUrl2: require('@/common/images/nodeService/fzlc1.png'),
          url: '',
          show: false,
        }, {
          title: '市场口碑',
          imgUrl: require('@/common/images/nodeService/sckb.png'),
          imgUrl2: require('@/common/images/nodeService/sckb1.png'),
          url: '',
          show: false,
        }, {
          title: '企业资质',
          imgUrl: require('@/common/images/nodeService/qyzz.png'),
          imgUrl2: require('@/common/images/nodeService/qyzz1.png'),
          url: '',
          show: false,
        }],
        curIndex:0
      }
    },
    methods:{
      showContent(e){
        this.curIndex = e
      }
    }
  }
</script>

<style>
  .banner_dfhj {
    position: absolute;
    top: 0;
    left: 0;
    width: 1920px;
    height: 900px;
    z-index: 0;
  }

  .zwdf {
    width: 1920px;
    height: 815px;
  }

  .menu_dfhj {
    width: 1656px;
    height: 174px;
    margin: 0 auto;
    position: relative;
  }

  .img_dfhj {
    width: 1656px;
    height: 174px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .line_dfhj {
    width: 1575px;
    height: 92px;
    position: absolute;
    left: 38px;
    top: 36px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 2;
  }

  .menu_item {
    width: 315px;
    height: 93px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #000;
  }

  .menu_item_active {
    background-color: #0caedc;
    color: #fff;
  }

  .menu_icon {
    width: 23px;
    height: 23px;
    margin-right: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/views/nodeService.vue